import React from 'react';
import { Descriptions } from 'antd';
import strings from '../../utils/strings';
import { useReportsStore } from '../../store/slices/createReportsSlice';

export default function InstallmentTotal() {
    const reports = useReportsStore();
    const data = reports.installment.data || {};
    const installments = data.Installments || [];

    if (!data || (!data.TotalCount && !installments.length)) {
        return null;
    }

    return (
        <div style={{ marginTop: "10px" }}>
            <Descriptions column={3} bordered size="small">
                <Descriptions.Item label="تعداد کل اقساط">{strings.getFarsiNum(data.TotalCount ?? 0)}&nbsp;</Descriptions.Item>
                <Descriptions.Item label="مجموع مبلغ اقساط">{strings.currencyFormat(data.TotalAmount ?? 0)}&nbsp;ریال</Descriptions.Item>
                <Descriptions.Item label="سطرهای نمایش داده شده">{strings.getFarsiNum(installments.length)}&nbsp;</Descriptions.Item>
            </Descriptions>
        </div>
    );
}



